
      const search = {
  "name": null,
  "identification": "Идентификация",
  "所属机构": "Организация",
  "日志类型": "Тип журнала",
  "登录方式": "Платформа",
  "模糊查询": "Нечеткий запрос",
  "发生时间": "Время",
  "序列号": "СН",
  "实体": "Объект",
  "告警状态": "Статус тревоги",
  "告警时间": "Время тревоги",
  "设备类型": "Модель",
  "生产日期": "Создать время",
  "选择日期": "Выбрать дату",
  "大于": "Более чем",
  "小于": "Менее чем",
  "之间": "Между",
  "之前": "До",
  "之后": "После",
  "选择时间": "Выбрать время",
  "分组": "Группа",
  "姓名": "Название",
  "身份证号": "ID",
  "身份证": "ID",
  "性别": "Пол",
  "住址": "Адрес",
  "工作单位": "Компания",
  "信用评价": "Кредит",
  "备注": "Ремарка",
  "selectDeviceModel": "Выберите модель устройства",
  "设备号/序列号": "Экстра/СН",
  "请选择分组": "Выберите группу",
  "请输入序列号SN": "Введите СН устройства",
  "请输入实体姓名": "Введите название объекта",
  "请选择告警状态": "Выберите статус тревоги",
  "请选择日志类型": "Выберите тип журнала",
  "请选择登录方式": "Выберите тип входа",
  "请输入要查询的内容": "Введите необходимый запрос"
}
      export default search
    